import * as actionTypes from "../actionTypes";

export const updateBillCompareOutput = (payload) => {
  return {
    type: actionTypes.SET_BILL_COMPARE_OUTPUT,
    payload,
  };
};
